<div class="modal-header text-white">
  <h4 class="modal-title" i18n>About DER Optimization Software</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <app-version-info name="{{versions?.build.name}}" version="{{versions?.build.version}}"></app-version-info>
  <div *ngFor="let svc of versions?.services">
    <app-version-info name="{{svc.name}}" version="{{svc.version}}"></app-version-info>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')" i18n>Close</button>
</div>
